// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"ea97a7c4","551":"258d7b3b","720":"4dbf1f3f","979":"4537ce7b"}[chunkId] + ".chunk.css";
};